import { userConstants } from "./Constants";

const initialState = {
  firstName: "",
  lastName: "",
  fullName: "",
  phoneNum: "",
  loggedIn: false,
  loggingIn: false,
  loginError: false,
  user: null,
  orgUserList: [],
  sopAccessAuthorized: null,
  socialError: false,
  activationFlow: false,
  showActivationPopUp: false,
  showEditProfilePopUp: false,
  showChangePasswordPopUp: false,
  showGiveFeedbackPopUp: false,
  showMyNotificationsPopUp: false,
  showFeatureToggle: false,
  showUserDetailsAdmin: false,
  createNewUserAdmin: false,
  successToast: false,
  successToastMessage: "",
  createNewCertificate: false,
  showCertificatePopup: false,
  isUserOrgAdmin: false,
  isUserUnauthorised: false,
  showDataExportPopup: false,
};

export function login(state = initialState, action) {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return {
        ...state,
        loggingIn: true,
        user: action.user,
      };
    case userConstants.LOGIN_SUCCESS:
      return {
        ...state,
        loggedIn: true,
        loggingIn: false,
        user: action.user,
      };
    case userConstants.LOGIN_FAILURE:
      return {
        ...state,
        loggedIn: false,
        loggingIn: false,
        loginError: true,
      };
    case userConstants.SOCIAL_LOGIN_ERROR:
      return {
        ...state,
        loggedIn: false,
        loggingIn: false,
        socialError: userConstants.SOCIAL_LOGIN_ERROR,
      };
    case userConstants.CANCEL_SOCIAL_LOGIN_FAILURE:
      return {
        ...state,
        loggedIn: false,
        loggingIn: false,
        socialError: false,
      };
    case userConstants.SOCIAL_EMAIL_ALREADY_EXISTS:
      return {
        loggedIn: false,
        loggingIn: false,
        socialError: userConstants.SOCIAL_EMAIL_ALREADY_EXISTS,
      };
    case userConstants.ACTIVATE_DEVICE_FLOW:
      return {
        ...state,
        activationFlow: action.activationFlow,
      };
    case userConstants.SOP_ACCESS_SET:
      return {
        ...state,
        sopAccessAuthorized: !!action.sopAccess.is_authorized,
      };
    case userConstants.SET_ORG_USER_LIST:
      return {
        ...state,
        orgUserList: Array.isArray(action.orgUserList) ? action.orgUserList : [],
      };
    case userConstants.LOGOUT:
      return {
        ...initialState,
      };
    case userConstants.SHOW_ACTIAVTION_POPUP:
      return {
        ...state,
        showActivationPopUp: action.showActivationPopup,
      };
    case userConstants.SHOW_USER_DETAILS_ADMIN:
      return {
        ...state,
        showUserDetailsAdmin: action.showUserDetailsAdmin,
      };
    case userConstants.CREATE_NEW_USER_ADMIN:
        return {
          ...state,
          createNewUserAdmin: action.createNewUserAdmin,
        };
    case userConstants.SUCCESS_TOAST:
      return {
        ...state,
        successToast: action.successToast,
      };
    case userConstants.SUCCESS_TOAST_MESSAGE:
      return {
        ...state,
        successToastMessage: action.successToastMessage,
      };
    case userConstants.CREATE_NEW_CERTIFICATE:
      return {
        ...state,
        createNewCertificate: action.createNewCertificate,
      };
    case userConstants.SHOW_CERTIFICATE_POPUP:
      return {
        ...state,
        showCertificatePopup: action.showCertificatePopup,
      };
    case userConstants.SHOW_EDIT_PROFILE_POPUP:
      return {
        ...state,
        showEditProfilePopUp: action.showEditProfilePopUp,
      };
    case userConstants.UPDATE_USER:
      return {
        ...state,
        user: { ...state.user, user: [action.user] },
      };
      case userConstants.SHOW_GIVEFEEDBACK_POPUP:
        return {
          ...state,
          showGiveFeedbackPopUp: action.showGiveFeedbackPopUp,
        };
      case userConstants.SHOW_MY_NOTIFICATIONS_POPUP:
      return {
        ...state,
        showMyNotificationsPopUp: action.showMyNotificationsPopUp,
      };
      case userConstants.SHOW_CHANGE_PASSWORD_POPUP:
        return {
          ...state,
          showChangePasswordPopUp: action.showChangePasswordPopUp,
        };
        case userConstants.SHOW_FEATURE_TOGGLE:
          return {
            ...state,
            showFeatureToggle: action.showFeatureToggle,
          };
        case userConstants.IS_USER_ORG_ADMIN:
          return {
            ...state,
            isUserOrgAdmin: action.isUserOrgAdmin,
          };
        case userConstants.IS_USER_UNAUTHORISED:
          return {
            ...state,
            isUserUnauthorised: action.isUserUnauthorised,
          };
        case userConstants.SHOW_DATA_EXPORT_POPUP:
          return {
            ...state,
            showDataExportPopup: action.showDataExportPopup,
          };
    default:
      return state;
  }
}

export function registration(state = initialState, action) {
  switch (action.type) {
    case userConstants.REGISTER_REQUEST:
      return {
        loggingIn: true,
        user: action.user,
      };
    case userConstants.REGISTER_SUCCESS:
      return {
        loggedIn: true,
        loggingIn: false,
        user: action.user,
      };
    case userConstants.REGISTER_FAILURE:
      return {
        loginError: true,
        loggedIn: false,
        loggingIn: false,
      };
    default:
      return state;
  }
}
